<template>
	<PayUnlockShell v-bind="shellProps" @select="$emit('select')">
		<template #left>
			<PayIcon icon="trial" color="#fff" :bg="btnColor" :h5="h5" />
		</template>
		<template #info>
			<p class="g-block-pay-unlock__title">
				{{ data.title || '爆款短视频训练营' }}
			</p>
			<p class="g-block-pay-unlock__desc">{{ data.subtitle || '解锁全部视频' }}</p>
			<div v-if="hasPrice" class="g-block-pay-unlock__prices" style="margin-top: 4px;">
				<span class="g-block-pay-unlock__price g-block-pay-unlock__price--sm" :style="priceColor">¥ {{ displayPrice }}</span>
			</div>
		</template>
		<template #action>
			<PayUnlockButton
				:text="data.buttonText || '立即观看'"
				:style="buttonStyle"
				@click="onButtonClick"
			/>
		</template>
	</PayUnlockShell>
</template>

<script>
	import PayUnlockShell from '../shared/PayUnlockShell.vue';
	import PayUnlockButton from '../shared/PayUnlockButton.vue';
	import PayIcon from '../shared/PayIcon.vue';
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice, getButtonColor } from '../shared/utils.js';
	import { DEFAULT_PAY_UNLOCK_TRIAL } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockTrial',
		components: { PayUnlockShell, PayUnlockButton, PayIcon },
		mixins: [payUnlockMixin],
		computed: {
			defaultButtonColors() {
				return DEFAULT_PAY_UNLOCK_TRIAL;
			},
			btnColor() {
				return getButtonColor(this.data, DEFAULT_PAY_UNLOCK_TRIAL);
			},
			priceColor() {
				return { color: this.btnColor };
			},
			shellProps() {
				return {
					data: this.data,
					editable: this.editable,
					active: this.active,
					fixedBottom: this.fixedBottom,
					h5: this.h5,
				};
			},
			displayPrice() {
				return formatPayPrice(this.data.price);
			},
			hasPrice() {
				return this.data.price !== '' && this.data.price != null;
			},
		},
	};
</script>
